export default "__VITE_ASSET__B8XsR$4h__"